import { CommonModule as NgCommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { TranslateModule } from '@ngx-translate/core';

import { AuthGuardService as AuthGuard } from "../../services/auth-guard";
import { CodeComponent } from "./code/code.component";
import { EditPasswordComponent } from "./edit-password/edit-password.component";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { InterfaceComponent } from "./interface/interface.component";
import { MainProfileComponent } from "./main-profile/main-profile.component";
import { ProfileNavComponent } from "./profile-nav/profile-nav.component";
import { environment } from "src/environments/environment";

const staticChildren: any = [
  {path: "code", component: CodeComponent },
  {path: "", component: MainProfileComponent},
  {path: "changepassword", component: EditPasswordComponent},
  {path: "editprofile", component: EditProfileComponent},
  {path: "interface", component: InterfaceComponent}
]

let children = staticChildren
// if (environment.showProfileData) {
//   children = children.concat({ path: "", component: MainProfileComponent })
// }

// if (environment.showProfileChangePassword) {
//   children = children.concat({ path: "changepassword", component: EditPasswordComponent })
// }

// if (environment.showProfileEdit) {
//   children = children.concat({ path: "editprofile", component: EditProfileComponent })
// }

// if (environment.showProfileRepresentation) {
//   children = children.concat({ path: "interface", component: InterfaceComponent })
// }


const routes: Routes = [
  {
    path: "profile",
    component: ProfileNavComponent,
    canActivate: [AuthGuard],
    children
  }
];

@NgModule({
  imports: [
    NgCommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    TranslateModule
  ],
  declarations: [
    ProfileNavComponent,
    EditPasswordComponent,
    InterfaceComponent,
    CodeComponent,
    MainProfileComponent,
    EditProfileComponent
  ],
  exports: [
    TranslateModule
  ]
})
export class ProfileModule {}
